import Swiper, { Navigation } from 'swiper'
Swiper.use([Navigation])

export const initPhotoCarousel = () => {
  const carousels = [...document.querySelectorAll('.js-photo-carousel')]

  if (carousels.length <= 0) { return false }

  carousels.forEach(carousel => {
    let carouselContainer = carousel.querySelector('.swiper-container')
    let next = carousel.querySelector('.swiper-button-next.photo_next')
    let prev = carousel.querySelector('.swiper-button-prev.photo_prev')
    let scrollbar = carousel.querySelector('.swiper-scrollbar')

    const photoSwiper = new Swiper(carouselContainer, {
      direction: 'horizontal',
      loop: false,
      watchOverflow: true,
      scrollbar: {
        el: scrollbar,
        draggable: true
      },
      slidesPerView: 1,
      navigation: {
        nextEl: next,
        prevEl: prev
      }
    })

    const subtitles = [...carousel.closest('section').querySelectorAll('.image_subtitle')]
    if (subtitles.length <= 0) { return false }

    photoSwiper.on('slideChange', () => {
      for (let i = subtitles.length - 1; i >= 0; i--) {
        subtitles[i].classList.remove('is-visible')
      }

      carousel.closest('section').querySelector(`.image_subtitle_${photoSwiper.activeIndex}`).classList.add('is-visible')
    })
  })
}
